"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalRepositoryLocationSwitchModule = /** @class */ (function () {
    function LocalRepositoryLocationSwitchModule() {
    }
    return LocalRepositoryLocationSwitchModule;
}());
exports.LocalRepositoryLocationSwitchModule = LocalRepositoryLocationSwitchModule;
